import { useQuery } from '@apollo/client';
import React from 'react';
import { Table } from 'react-bootstrap';
import { gqlGetContributions } from '../graphql';
import { FileRepoLink } from 'shared-pages/components/filerepo-link';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import './current-year-contributions.css';

export const CurrentYearContributions = () => {
  const { t, i18n } = useTranslation();
  const gr = i18n.language === 'gr';
  const curYear = new Date().getFullYear();
  const years = [curYear, curYear - 1, curYear - 2, curYear - 3, curYear - 4, curYear - 5];

  const {
    loading,
    data: rawData,
    error,
  } = useQuery(gqlGetContributions, {
    variables: {
      order: 'periodId',
    },
    fetchPolicy: 'no-cache',
  });

  if (loading) return <>{t('Παρακαλώ περιμένετε...')}</>;
  if (error) return <>{t('Σφάλμα φόρτωσης εισφορών')}</>;

  const contributionsByYear = rawData?.getCntContributions?.data?.reduce((acc, contribution) => {
    const year = contribution.year; // Use year from data instead of declarationDate
    if (years.includes(year)) {
      if (!acc[year]) acc[year] = [];
      acc[year].push(contribution);
    }
    return acc;
  }, {});

  return (
    <div className="contributions-section">
      {years
        .filter((year) => contributionsByYear[year]?.length)
        .map((year) => (
          <div key={year} className="contributions-year-card">
            <h5 className="contributions-year-title">
              {t(year === curYear ? 'Εισφορές τρέχοντος Έτους' : 'Εισφορές έτους')} {year}
            </h5>
            <div className="contributions-table-wrap">
              <Table borderless responsive={false} className="contributions-table">
                <colgroup>
                  <col className="contributions-col-period" />
                  <col className="contributions-col-status" />
                  <col className="contributions-col-date" />
                  <col className="contributions-col-invoice" />
                </colgroup>
                <thead>
                  <tr>
                    <th>{t('Περίοδος')}</th>
                    <th>{t('Κατάσταση')}</th>
                    <th>{t('Ημερομηνία')}</th>
                    <th>{t('Τιμολόγιο')}</th>
                  </tr>
                </thead>
                <tbody>
                  {contributionsByYear[year].map((v) => (
                    <tr key={v.id}>
                      <td className="text-center">
                        <Link
                          to={`/contribution/${v.id}`}
                          className="d-block contributions-period-link"
                        >
                          {gr ? v.contributionperiod.name : v.contributionperiod.enName}
                        </Link>
                      </td>
                      {/* Το όνομα κατάστασης έρχεται ελληνικό ή με ορθογραφικό από τη βάση */}
                      <td className="text-center">
                        {v.contributionstate?.name ? t(v.contributionstate.name) : ''}
                      </td>
                      <td className="text-center">
                        {v.declarationDate ? format(parseISO(v.declarationDate), 'dd/MM/yyyy') : ''}
                      </td>
                      <td className="contributions-invoice-cell">
                        {v.invoiceFile && (
                          <FileRepoLink
                            fileId={v.invoiceFile?.id}
                            fileName={v.invoiceFile?.fileName}
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        ))}
    </div>
  );
};
